import loc from 'owa-localize';
import mountAndShowFullOptions from '../../utils/mountAndShowFullOptions';
import { OptionWithPath } from 'owa-options-store';
import { observer } from 'mobx-react';

import * as React from 'react';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';

const styles = require('./QuickOptions.scss');
const classNames = require('classnames/bind').bind(styles);

export interface QuickOptionSearchEntryProps {
    onDismiss?: () => void;
    option: OptionWithPath;
}

@observer
export default class QuickOptionSearchEntry extends React.Component<
    QuickOptionSearchEntryProps,
    {}
> {
    render() {
        let { option } = this.props;

        return (
            <div className={styles.quickSetting}>
                <CommandButton
                    text={loc(option.titleStringKey) as string}
                    className={classNames(styles.quickSettingHeader, styles.isSearch)}
                    onClick={this.onHeaderClick}
                />
            </div>
        );
    }

    private onHeaderClick = () => {
        mountAndShowFullOptions(
            this.props.option.categoryKey,
            this.props.option.subcategoryKey,
            this.props.option.key
        );
        if (this.props.onDismiss) {
            this.props.onDismiss();
        }
    };
}
